import { createContext } from "react";

const ModeContext = createContext();

export default ModeContext;
